module.exports = __webpack_public_path__ + "media/application/images/svgs/bar-chart-3652b22a9e396c79467ac9658536dfa9.svg";